import React from 'react';
import Pledges_title from '../../components/pledges/pledges_title';
import Positions from '../../components/pledges/positions';
import Meta from '../../components/Meta';
import Parks from '../../components/pledges/parks';
import { Partners } from '../../components/component';

const Pledges = () => {
	return (
		<div className="mt-[95px]">
			<Meta title="CarbonPump" />
			<Pledges_title />
			<Positions />
		</div>
	);
};

export default Pledges;
